import React, { PureComponent } from 'react';

import AvatarBase from './avatar-base';
import FileUpload from './file-upload';

export default class FieldAvatar extends PureComponent {
    render() {
        return (
            <div className={'field-avatar ' + this.props.className}>
                <AvatarBase {...this.props}>
                    {
                        !this.props.readOnly ? (
                            <FileUpload single={true} withBase64={true} preventLimitCheck={true} onChange={this.props.onChange} />
                        ) : null
                    }
                </AvatarBase>

                {
                    !this.props.readOnly && this.props.btnText ? (
                        <span className="btn btn-upload btn-xsmall btn-secondary btn-secondary-dimmed btn-border">
                            <FileUpload single={true} withBase64={true} preventLimitCheck={true} onChange={this.props.onChange} />

                            {this.props.btnText}
                        </span>
                    ) : null
                }
            </div>
        )
    }
}
